import { filterTypes } from '@nykaa/listing-shared/constants/filter';
import { FILTER_APPLIED } from 'constants/filterTypes';
import { pushEvent } from 'helpers/utils/dataLayer';
import { capitalize } from 'helpers/utils/strings';

export const FILTER_KEY_REGEX = /_filter$/;

const PageName = {
  search: 'Search List Page',
  brand: 'Brand Page',
  category: 'Category Page',
};

const ChangeEvent = 'event56';
const sortEvent = 'event137';

interface PageData {
  pageType: string;
  pageTitle: string;
}

export const getLocation = (pageData: PageData) => {
  const { pageType = '', pageTitle } = pageData || {};
  const pageLocation = PageName[pageType.toLowerCase()] || '';

  if (pageLocation && pageTitle) {
    const location = `${capitalize(__PLATFORM__)}:${pageLocation}:${pageTitle}`;
    return location;
  }
  return '';
};

export const trackSort = (selectedValue: string, pageData: PageData) => {
  const location = getLocation(pageData);
  if (location && selectedValue) {
    pushEvent(sortEvent, {
      sortLocation: location,
      sortSelection: selectedValue,
    });
  }
};

export const trackFilter = (selectedFilter: any, pageData: PageData) => {
  if (!selectedFilter) {
    return;
  }

  const selectedFilterKeys = Object.keys(selectedFilter).filter((key) =>
    FILTER_KEY_REGEX.test(key)
  );
  let filterDataString = '';

  selectedFilterKeys.forEach((filterKey, index) => {
    const { title, type, data: filterValues } = selectedFilter[filterKey];

    switch (type) {
      case filterTypes.SINGLE_SELECT:
        filterDataString += `${title}:${filterValues.id}`;
        break;
      case filterTypes.COLOR:
      case filterTypes.CATEGORY:
      case filterTypes.MULTI_SELECT:
        filterDataString += `${title}:`;

        filterValues.forEach((filterItem: any, filterValueIndex: number) => {
          filterDataString += filterItem.id;
          if (filterValueIndex !== filterValues.length - 1) {
            // We skip the trailing "," if the value is last among
            filterDataString += ',';
          }
        });
        break;
      default:
        break;
    }

    if (index !== selectedFilterKeys.length - 1) {
      filterDataString += '|';
    }
  });

  const location = getLocation(pageData);
  if (location) {
    pushEvent(ChangeEvent, {
      filterLocation: location,
      filterSelection: filterDataString,
    });
    pushEvent(FILTER_APPLIED);
  }
};
